import VueRouter from 'vue-router'
import user from './user'
import account from './account'
import manage from './manage'
import system from './system'
import report from './report'
import basic from './basic'
import goods from './goods'
import purchasing from './purchasing'
import orders from './sale'
import custom from './custom'
import member from './member'
import warehouse from './warehouse'
import finance from './finance'
import supplier from './supplier'
import recharge from './recharge'
import symbols from './symbols'

const index = {
  path: '/',
  component: () => import('@/layouts/BaseLayout'),
  redirect: '/custom',
  children: [
    //{
    //  path: '/custom',
    //  name: 'custom',
    //  meta: { title: '客户管理' },
    //  component: () => import('@/views/custom/index'),
   // },
  ]
}

const routes = [index,symbols, user,member, account, manage, system, report, basic, goods, purchasing, orders, warehouse, finance,custom,supplier,recharge];

export default new VueRouter({ mode: 'history', routes })
